import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { Image as ImageIcon, Plus, Trash2 } from "lucide-react";

const EMPTY = { title:"", image_url:"", category:"Nail Art", description:"" };

export default function GalleryTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);

  const load = () => { api.get("/gallery").then(r=>setItems(r.data)); };
  useEffect(load, []);

  const save = async () => {
    if (!form.title || !form.image_url) return toast.error("Título e URL da imagem são obrigatórios");
    if (!/^https?:\/\//i.test(form.image_url)) return toast.error("A imagem deve ser uma URL http(s)");
    try {
      await api.post("/admin/gallery", form);
      toast.success("Foto adicionada");
      setForm(EMPTY); load();
    } catch { toast.error("Falha ao salvar"); }
  };
  const del = async (id) => { if (!window.confirm("Excluir esta foto?")) return; await api.delete(`/admin/gallery/${id}`); load(); };

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {items.map(p => (
          <div key={p.photo_id} className="card-arya overflow-hidden group" data-testid={`gal-${p.photo_id}`}>
            <div className="relative aspect-square bg-[var(--cream-100)]">
              <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" onError={(e)=>{ e.target.style.opacity=0.3; }}/>
              <button onClick={()=>del(p.photo_id)} className="absolute top-2 right-2 p-1.5 rounded-full bg-white/90 text-[color:var(--danger)] opacity-0 group-hover:opacity-100 transition" data-testid={`del-gal-${p.photo_id}`}><Trash2 size={12}/></button>
            </div>
            <div className="p-3">
              <p className="tag-sun inline-block mb-1">{p.category}</p>
              <p className="font-display font-semibold text-sm">{p.title}</p>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full card-arya p-10 text-center text-[color:var(--ink-500)]">Nenhuma foto na galeria ainda.</div>}
      </div>

      <div className="card-arya p-6 h-fit">
        <h3 className="font-serif text-xl mb-3 flex items-center gap-2"><ImageIcon size={16}/> Nova foto</h3>
        <div className="space-y-2">
          <input placeholder="Título (ex: Nail Art Nude)" value={form.title} onChange={e=>setForm({...form, title:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="gal-title"/>
          <input placeholder="URL da imagem (https://...)" value={form.image_url} onChange={e=>setForm({...form, image_url:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="gal-url"/>
          <input placeholder="Categoria" value={form.category} onChange={e=>setForm({...form, category:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm"/>
          <textarea rows="2" placeholder="Descrição (opcional)" value={form.description} onChange={e=>setForm({...form, description:e.target.value})}
                    className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm"/>
          <button onClick={save} className="btn-gold w-full inline-flex items-center justify-center gap-1" data-testid="btn-save-gal"><Plus size={14}/> Adicionar à galeria</button>
          <p className="text-[10px] text-[color:var(--ink-500)] leading-relaxed pt-1">
            Cole a URL de uma foto pública (Instagram, Google Fotos, Drive com link compartilhado, Imgur, etc). Aparecerá na página <b>/galeria</b> do site.
          </p>
        </div>
      </div>
    </div>
  );
}
